<template>
  <div class="right-stat">
    <div class="right-stat-item" v-for="item in chartList" :key="item.el">
      <div class="right-stat-item-header">{{ item.text }}</div>
      <div :id="item.el" style="width: 315px; height: 270px"></div>
    </div>
    <div class="right-stat-project">
      <UserProjectList />
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'
import moment from 'moment'
import _ from 'lodash'
import { mapGetters } from 'vuex'
import { initLine, getMonthDays, initPie } from '../echartOptions'
import UserProjectList from '../statTwo/UserProjectList'
import { yesterdayDate, monthStartDate, monthEndDate } from '../constantDate'

export default {
  name: 'AllStatRight',
  components: {
    UserProjectList,
  },
  computed: {
    ...mapGetters({
      allOverview: 'statPage/allOverview',
      regionChildStat: 'statPage/regionChildStat',
      regionStat: 'statPage/regionStat',
    }),
    regionId() {
      return +this.$route.query.regionId
    },
    regionName() {
      return this.$route.query.regionName
    },
    regionCode() {
      return this.$route.query.regionCode
    },
    regionHasChild() {
      return _.includes(this.regionCode, '_full')
    },
    overviewByRegion() {
      const key = `${this.regionId}&${yesterdayDate}&${yesterdayDate}`
      return this.allOverview[key] || {}
    },
    yesterdayChildStat() {
      const key = `${this.regionId}&${yesterdayDate}&${yesterdayDate}`
      return this.regionChildStat[key] || []
    },
    // curYearfirst() {
    //   return `${moment().format('YYYY')}-01-31`
    // },
    // curYearEnd() {
    //   return `${moment().format('YYYY')}-12-31`
    // },
    // curYearStat() {
    //   const key = `${this.regionId}&${this.curYearfirst}&${this.curYearEnd}`
    //   return this.regionStat[key]
    // },
    curMonth() {
      return moment().format('YYYYMM')
    },
    curMonthStat() {
      const key = `${this.regionId}&${monthStartDate}&${monthEndDate}`
      return this.regionStat[key] || []
    },
    chartList() {
      const {
        activeSchoolCount = 0,
        school430Count = 0,
        schoolCampusCount = 0,
        // orgTotal = 0,
      } = this.overviewByRegion
      // const xDataByOneYear = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]
      const schoolRegionStatData = []
      const org430RegionStatData = []
      const schoolCampusRegionStatData = []
      // const schoolGrowStatData = []
      // const org430GrowStatData = []
      // // const orgRegionStatData = []
      // // const orgGrowStatData = []
      // const curYear = moment().format('YYYY')
      if (this.regionHasChild) {
        _.forEach(this.yesterdayChildStat, value => {
          if (value[0]) {
            schoolRegionStatData.push({
              value: value[0].activeSchoolCount || 0,
              name: value[0].name,
            })
            org430RegionStatData.push({
              value: value[0].school430Count || 0,
              name: value[0].name,
            })
            schoolCampusRegionStatData.push({
              value: value[0].schoolCampusCount || 0,
              name: value[0].name,
            })
            // orgRegionStatData.push({
            //   value: value[0].orgTotal || 0,
            //   name: value[0].name,
            // })
          }
        })
      } else {
        schoolRegionStatData.push({
          value: activeSchoolCount,
          name: this.regionName,
        })
        org430RegionStatData.push({
          value: school430Count,
          name: this.regionName,
        })
        schoolCampusRegionStatData.push({
          value: schoolCampusCount,
          name: this.regionName,
        })
        // orgRegionStatData.push({
        //   value: orgTotal,
        //   name: this.regionName,
        // })
      }
      // const monthLastDay = ['28', '29', '30', '31']
      // _.forEach(xDataByOneYear, item => {
      //   const curStat = _.find(this.curYearStat, e =>
      //     _.some(
      //       monthLastDay,
      //       day =>
      //         e.dimTimeId ===
      //         _.toNumber(`${curYear}${(item + '').padStart(2, 0)}${day}`)
      //     )
      //   )
      //   if (curStat) {
      //     schoolGrowStatData.push(curStat.activeSchoolCount || 0)
      //     org430GrowStatData.push(curStat.school430Count || 0)
      //     // orgGrowStatData.push(curStat.orgTotal || 0)
      //   } else {
      //     schoolGrowStatData.push(0)
      //     org430GrowStatData.push(0)
      //     // orgGrowStatData.push(0)
      //   }
      // })
      const xDataByMonth = getMonthDays(this.curMonth)
      const schoolGrowData = []
      const schoolCampusGrowData = []
      const school430GrowData = []
      _.forEach(xDataByMonth, item => {
        const curStat = _.find(
          this.curMonthStat,
          e =>
            e.dimTimeId ===
            _.toNumber(`${this.curMonth}${(item + '').padStart(2, 0)}`)
        )
        if (curStat) {
          schoolGrowData.push(curStat.activeSchoolCount || 0)
          schoolCampusGrowData.push(curStat.schoolCampusCount || 0)
          school430GrowData.push(curStat.school430Count || 0)
        } else {
          schoolGrowData.push(0)
          schoolCampusGrowData.push(0)
          school430GrowData.push(0)
        }
      })
      const schoolGrowStat = initLine(
        '学校、校本、社团增长情况',
        'school-grow-stat',
        ['学校', '校本', '社团'],
        xDataByMonth,
        '单位: 个',
        [schoolGrowData, schoolCampusGrowData, school430GrowData],
        '单位: 日',
        true
      )
      const schoolRegionStat = initPie(
        '区域学校数量',
        'school-region-stat',
        '单位: 个',
        schoolRegionStatData
      )
      const org430RegionStat = initPie(
        '区域社团（430）数量',
        'org430-region-stat-small',
        '单位: 个',
        org430RegionStatData
      )
      const schoolCampusRegionStat = initPie(
        '区域校本数量',
        'campus-region-stat-small',
        '单位: 个',
        schoolCampusRegionStatData
      )
      // const org430GrowStat = initLine(
      //   '社团（430）增长情况',
      //   'org430-grow-stat',
      //   [],
      //   xDataByOneYear,
      //   '单位: 个',
      //   [org430GrowStatData],
      //   '单位: 月',
      //   true
      // )
      // const orgGrowStat = initLine(
      //   '机构增长情况',
      //   'org-grow-stat-small',
      //   [],
      //   xDataByOneYear,
      //   '单位: 个',
      //   [orgGrowStatData],
      //   '单位: 月',
      //   true
      // )
      // const orgRegionStat = initPie(
      //   '区域机构数量',
      //   'org-region-stat-small',
      //   '单位: 个',
      //   orgRegionStatData
      // )
      return [
        schoolGrowStat,
        schoolRegionStat,
        org430RegionStat,
        schoolCampusRegionStat,
        // org430GrowStat,
        // orgGrowStat,
        // orgRegionStat,
      ]
    },
  },
  methods: {
    init() {
      this.chartList.forEach(item => {
        this.initChart(item.el, item.options)
      })
    },
    initChart(el, options) {
      const node = document.getElementById(el)
      const myChart = echarts.init(node)
      myChart.clear()
      myChart.setOption(options)
    },
  },
}
</script>

<style lang='scss'>
.right-stat {
  padding: 22px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .right-stat-item {
    width: 315px;
    margin-bottom: 10px;
    position: relative;
    &-header {
      height: 32px;
      font-size: 16px;
      line-height: 32px;
      padding-left: 14px;
      background-image: linear-gradient(
        0deg,
        #28466f 24%,
        rgba(40, 70, 111, 0.86) 38%,
        rgba(39, 54, 78, 0.5) 73%,
        #252a34 100%
      );
    }
  }
  .right-stat-project {
    width: 100%;
    .user-project-list-box-item {
      width: 320px;
      .project-cover {
        width: 286px;
      }
    }
  }
}
</style>